import React from 'react';

export interface FmlTabsContextState {
  activeTab: string | undefined;
  selectTab: (tab: string) => boolean;
}

export const FmlTabsContext = React.createContext<FmlTabsContextState>({
  activeTab: undefined,
  selectTab: () => false,
});
